import React, { useRef, useState } from 'react'
import './App.css';
import SignatureCanvas from 'react-signature-canvas'
import { CSSTransition } from 'react-transition-group'
import CertificateSVG from './components/CertificateSVG'
import Button from './components/Button'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

function App() {
  const [popup, setPopup] = useState(true)
  const [title, setTitle] = useState('Certificate of ');
  const [showEditTitle, setShowEditTitle] = useState(false)
  const [text, setText] = useState('');
  const [sign, setSign] = useState('unsign')
  const [canType, setCanType] = useState(true)
  const [showPad, setShowPad] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [complete, setComplete] = useState('uncomplete')
  const signature = useRef(null)
  const currentDate = useRef(null)
  const certificate = useRef(null)
  const [image, setImage] = useState(null)
  // const textarea = useRef(null)

  const textareaOnchangeHandler = (e) => {
    let adjustedHeight = e.target.clientHeight;

    adjustedHeight = Math.max(e.target.scrollHeight, adjustedHeight);
    if (adjustedHeight > e.target.clientHeight) {
      setCanType(false)
    } else {
      setCanType(true)
      setText(e.target.value)
    }
    console.log(e)
  }

  const onKeyPressHandler = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setText(text)
    }
  }

  const finishSig = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;
    currentDate.current = today
    setImage(signature.current.getTrimmedCanvas().toDataURL('image/png'))
    setShowPad(false)
    setSign('signed')
  }

  const onExport = (type) => {
    if (type === 'pdf') {
      const pdf = new jsPDF({
        orientation: 'landscape',
      });
      if (pdf) {
        html2canvas(certificate.current, {
          useCORS: true
        })
          .then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('download.pdf');
            setComplete('uncomplete')
          });
      }
    } else if (type === 'jpg') {
      html2canvas(certificate.current, {
        useCORS: true
      })
        .then(canvas => {
          const imgData = canvas.toDataURL('image/jpeg');
          let downloadLink = document.createElement('a');
          downloadLink.href = imgData;
          downloadLink.download = 'download.jpg';
          downloadLink.click();
          setComplete('uncomplete')
        });
    }

  }

  // Here you can write your feelings down, secure it, certificate it
  return (
    <div className="App">
      <div ref={certificate} className="certification">
        <div className="certification__innerContainer">
          <div className="certification__content">
            <h1 className="certification__title">{title}</h1>
            {complete === 'uncomplete' &&
              <Button
                onClick={() => setShowEditTitle(true)}
              >
                Edit Title
            </Button>
            }
            <img className="certification__divider" src='./images/divider.png' />
            {complete === 'choose' &&
              <p className="certification__paragraph">
                {text}
              </p>
            }
            {complete === 'uncomplete' &&
              <textarea
                name="content"
                className="certification__paragraph"
                value={text}
                onChange={textareaOnchangeHandler}
                onKeyPress={onKeyPressHandler}
                placeholder="Here you can write your feelings down, secure it, certificate it"
              />
            }
            {sign === 'unsign' &&
              <div className="certification__buttonContainer">
                <Button onClick={() => setSign('signing')}>
                  Click here to sign
                </Button>
              </div>
            }
            {sign === 'signed' &&
              <div className="certification__sigCongtainer">
                <img
                  src={image} />
                <span>{currentDate.current}</span>
              </div>
            }
            {complete === 'uncomplete' &&
              <div className="certification__submitContainer">
                <Button onClick={() => setComplete('choose')}>
                  Export
                        </Button>
              </div>
            }
            <img src="./images/stamp.png" className="certification__stamp" />
          </div>
        </div>
      </div>
      <CSSTransition
        in={showEditTitle}
        classNames="popup"
        timeout={300}
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__content">
              <h2>Edit title</h2>
              <div className="popup__inputContainer">
                <input className="certificate__input" placeholder="Certificate title" type="text" name="title" value={title} onChange={(e) => setTitle(e.target.value)}></input>
              </div>
              <div className="popup__buttonContainer">
                <Button onClick={() => setShowEditTitle(false)}>
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={popup}
        classNames="popup"
        timeout={300}
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__content">
              <div className="popup__iconContainer">
                <CertificateSVG />
              </div>
              <h2>Welcome to Certification</h2>
              <span className="popup__textContainer">Here you can write your feelings down, secure it, and certificate it.</span>
              <div className="popup__inputContainer">
                <input className="certificate__input" placeholder="Certificate title" type="text" name="title" value={title} onChange={(e) => setTitle(e.target.value)}></input>
              </div>
              <div className="popup__buttonContainer">
                <Button onClick={() => setPopup(!popup)}>
                  Start
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={sign === 'signing'}
        classNames="popup"
        timeout={500}
        onEntered={() => setShowPad(true)}
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__content">
              <h2>Sign your name</h2>
              <div className="popup__inputContainer" style={{ width: '500px', height: '200px' }}>
                {showPad &&
                  <SignatureCanvas
                    penColor='#586b7e'
                    canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                    ref={signature}
                  />
                }
              </div>
              <div className="popup__buttonContainer">
                <Button onClick={finishSig}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={complete === 'choose'}
        classNames="popup"
        timeout={500}
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__innerContainer">
              <div className="popup__content">
                <h2>Certificate Success!</h2>
              </div>
              <span className="popup__textContainer">Download as</span>
              <div className="popup__buttonContainer">
                <Button className="popup__exportButton" onClick={() => onExport('pdf')}>
                  PDF
                  </Button>
                <Button className="popup__exportButton" onClick={() => onExport('jpg')}>
                  JPG
                  </Button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={showEdit}
        classNames="popup"
        timeout={500}
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__innerContainer">
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
              >
              </textarea>
              <Button onClick={() => {
                setShowEdit(false)
              }}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div >
  );
}

export default App;